import { useState, useEffect, useRef } from "react";
import { RpaServices } from "../services/RpaServices";
import { CircularProgress } from "@mui/material";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import Select from "react-select";
import RpaAttempts from "./RpaAttempts";
import CustomPagination from "../utils/paginationUtils";
import { Close } from "@mui/icons-material";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { HospitalServices } from "../services/HospitalServices";
const RpaQueryRequestLog = () => {
  const [loading, setLoading] = useState(false);
  const [rpaProcessReport, setRpaProcessReport] = useState(null);
  const [rpaErrorLogs, setRpaErrorLogs] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(1);
  const [hospitalList, setHospitalList] = useState([]);
  const [applicationIds, setApplicationIds] = useState([]);
  const [hospitalId, setHospitalId] = useState("");
  const [requestStatus, setRequestStatus] = useState("");
  const [caseStatus, setCaseStatus] = useState("");
  const [targetRequests, setTargetRequests] = useState("processed");
  const [filterDateType, setFilterDateType] = useState("createdAt");
  const [processedBy, setProcessedBy] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [selectedRpaLog, setSelectedRpaLog] = useState(null);
  const [openErrorLog, setOpenErrorLog] = useState(false);
  const [rpaAttempt, setRpaAttempt] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const limit = 10;
  const searchTimeRef = useRef();
  function formatDateTime(isoString, useLocalTime = true) {
    const date = new Date(isoString);

    const pad = (num) => String(num).padStart(2, "0");

    const day = pad(useLocalTime ? date.getDate() : date.getUTCDate());
    const month = pad(
      (useLocalTime ? date.getMonth() : date.getUTCMonth()) + 1
    );
    const year = useLocalTime ? date.getFullYear() : date.getUTCFullYear();

    const hours = pad(useLocalTime ? date.getHours() : date.getUTCHours());
    const minutes = pad(
      useLocalTime ? date.getMinutes() : date.getUTCMinutes()
    );
    const seconds = pad(
      useLocalTime ? date.getSeconds() : date.getUTCSeconds()
    );

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }
  const getTime = (diffInS) => {
    const diffInMs = diffInS * 1000;
    const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (diffInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000);

    return `${days > 0 ? days + "D " : ""}${hours > 0 ? hours + "H " : ""} ${
      minutes > 0 ? minutes + "M" : ""
    } ${!days && !hours && !minutes ? seconds + " S" : ""}`;
  };
  const handleSearch = (e) => {
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };
  const getHoldCount = (hold, manually) => {
    if (hold) {
      if (!isNaN(manually)) {
        return hold + manually;
      }
      return hold;
    } else {
      if (!isNaN(manually)) {
        return manually;
      }
    }
    return 0;
  };
  const getHospitalList = async () => {
    try {
      const response = await HospitalServices.gethospitals("", 1, 1500);
      setHospitalList(response.data.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getApplicationIds = async () => {
    try {
      const res = await RpaServices?.manageApplicationId();
      setApplicationIds(res?.data?.applications);
      console.log("application Id:", res?.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const adjustDateRange = (fromISO, toISO) => {
    if (!fromISO || !toISO) return { fromDate: fromISO, toDate: toISO };

    const from = new Date(fromISO);
    const to = new Date(toISO);

    if (
      from.getFullYear() === to.getFullYear() &&
      from.getMonth() === to.getMonth() &&
      from.getDate() === to.getDate()
    ) {
      // same day: set toDate to end of the day
      const endOfDay = new Date(to);
      endOfDay.setHours(23, 59, 59, 999);
      return { fromDate: from.toISOString(), toDate: endOfDay.toISOString() };
    }
    return { fromDate: fromISO, toDate: toISO };
  };

  const getRpaProcessReport = async () => {
    try {
      const { fromDate: adjustedFrom, toDate: adjustedTo } = adjustDateRange(
        fromDate,
        toDate
      );

      const res = await RpaServices.getRpaRequestProcessReport(
        page,
        limit,
        searchKey,
        adjustedFrom,
        adjustedTo
      );
      setRpaProcessReport(res?.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const getRpaErrorLogs = async () => {
    setLoading(true);
    try {
      const { fromDate: adjustedFrom, toDate: adjustedTo } = adjustDateRange(
        fromDate,
        toDate
      );

      const res = await RpaServices?.getRpaErrorLogs(
        page,
        limit,
        searchKey,
        adjustedFrom,
        adjustedTo,
        hospitalId,
        requestStatus,
        caseStatus,
        processedBy,
        targetRequests,
        ownerName,
        filterDateType
      );
      setRpaErrorLogs(res?.data?.requests);
      setTotalPages(res?.data?.totalPages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getHospitalList();
    getApplicationIds();
  }, []);
  useEffect(() => {
    getRpaProcessReport();
  }, [fromDate, toDate]);
  useEffect(() => {
    getRpaErrorLogs();
  }, [
    page,
    searchKey,
    fromDate,
    toDate,
    hospitalId,
    requestStatus,
    caseStatus,
    processedBy,
    targetRequests,
    ownerName,
    filterDateType,
  ]);
  return (
    <div className="initiateadmission-box">
      {" "}
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp;/ &nbsp;
        Dashboard &nbsp;/ &nbsp; RPA Query Request Logs
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">RPA Query Request Logs</div>
        <div className="flex gap-2 items-center">
          <Select
            name="targtRequest"
            isClearable
            options={[
              { label: "Processed", value: "processed" },
              { label: "Non Processed", value: "nonprocessed" },
            ]}
            getOptionLabel={(options) => options["label"]}
            getOptionValue={(options) => options["value"]}
            onChange={(item) => {
              setPage(1);
              item ? setTargetRequests(item.value) : setTargetRequests("");
            }}
            value={[
              { label: "Processed", value: "processed" },
              { label: "Non Processed", value: "nonprocessed" },
            ].filter((option) => option.value === targetRequests)}
            placeholder="FILTER "
          />
          <Select
            name="dateType"
            isClearable
            options={[
              { label: "Created At", value: "createdAt" },
              { label: "Updated At", value: "updatedAt" },
            ]}
            getOptionLabel={(options) => options["label"]}
            getOptionValue={(options) => options["value"]}
            onChange={(item) => {
              setPage(1);
              item ? setFilterDateType(item.value) : setFilterDateType("");
            }}
            value={[
              { label: "Created At", value: "createdAt" },
              { label: "Updated At", value: "updatedAt" },
            ].filter((option) => option.value === filterDateType)}
            placeholder="Filter By Date Type"
          />
          {/* <div
            style={{ border: "1px solid #E4E4E4" }}
            className="flex gap-2 px-2 py-2 rounded-[8px] "
          >
            <SearchIcon />
            <input
              type="text"
              className="outline-none border-0"
              placeholder="Search Anything"
              onChange={handleSearch}
            />
          </div> */}
        </div>
      </div>
      <div className="flex flex-wrap gap-3 items-center text-sm 2xl:text-base">
        <div>
          <label htmlFor="start-date">From Date:</label>
          <input
            type="date"
            id="from-date"
            // value={formatDate(startDate)}
            onChange={(e) =>
              setFromDate(new Date(e.target.value).toISOString())
            }
            // max={formatDate(new Date())}
            style={{ border: "1px solid #E5E5E5" }}
            className="text-[#191919] appearance-none p-2 rounded-[8px] "
          />
        </div>

        <div>
          <label htmlFor="end-date">To Date:</label>
          <input
            type="date"
            id="to-date"
            // value={formatDate(endDate)}
            onChange={(e) => setToDate(new Date(e.target.value).toISOString())}
            // max={formatDate(new Date())}
            style={{ border: "1px solid #E5E5E5" }}
            className="text-[#191919] appearance-none p-2 rounded-[8px] "
          />
        </div>
        <Select
          name="hospitalId"
          isClearable
          options={hospitalList}
          getOptionLabel={(options) => options["name"]}
          getOptionValue={(options) => options["id"]}
          onChange={(item) => {
            setPage(1);
            item ? setHospitalId(item.id) : setHospitalId("");
          }}
          value={hospitalList.filter((item) => item.id === hospitalId)}
          placeholder="FILTER HOSPITAL WISE"
        />
        <Select
          name="owner name"
          isClearable
          options={applicationIds}
          getOptionLabel={(options) => options["ownerName"]}
          getOptionValue={(options) => options["ownerName"]}
          onChange={(item) => {
            setPage(1);
            item ? setOwnerName(item.ownerName) : setOwnerName("");
          }}
          placeholder="FILTER OWNER"
        />

        <Select
          name="status"
          isClearable
          options={[
            { label: "New", value: "NEW" },
            { label: "Hold", value: "HOLD" },
            { label: "Completed", value: "COMPLETED" },
            { label: "Start Manually", value: "STARTMANUALLY" },
          ]}
          getOptionLabel={(options) => options["label"]}
          getOptionValue={(options) => options["value"]}
          onChange={(item) => {
            setPage(1);
            item ? setRequestStatus(item.value) : setRequestStatus("");
          }}
          value={[
            { label: "New", value: "NEW" },
            { label: "Hold", value: "HOLD" },
            { label: "Completed", value: "COMPLETED" },
            { label: "Start Manually", value: "STARTMANUALLY" },
          ].filter((option) => option.value === requestStatus)}
          placeholder="FILTER STATUS WISE"
        />
        <Select
          name="caseStatus"
          isClearable
          options={[
            { label: "New Case", value: "NEW_CASE" },
            { label: "Status Update", value: "STATUS_UPDATE" },
            { label: "Upload Document", value: "UPLOAD_DOCUMENT" },
          ]}
          getOptionLabel={(options) => options["label"]}
          getOptionValue={(options) => options["value"]}
          onChange={(item) => {
            setPage(1);
            item ? setCaseStatus(item.value) : setCaseStatus("");
          }}
          value={[
            { label: "New Case", value: "NEW_CASE" },
            { label: "Status Update", value: "STATUS_UPDATE" },
            { label: "Upload Document", value: "UPLOAD_DOCUMENT" },
          ].filter((option) => option.value === caseStatus)}
          placeholder="FILTER REQUEST TYPE WISE"
        />
        <Select
          name="caseStatus"
          isClearable
          options={[
            { label: "Manually", value: "MANUALLY" },
            { label: "RPA", value: "RPA" },
          ]}
          getOptionLabel={(options) => options["label"]}
          getOptionValue={(options) => options["value"]}
          onChange={(item) => {
            setPage(1);
            item ? setProcessedBy(item.value) : setProcessedBy("");
          }}
          // value={[
          //   { label: "Manually", value: "MANUALLY" },
          //   { label: "RPA", value: "RPA" },
          // ].filter((option) => option.value === caseStatus)}
          placeholder="PROCESSED BY"
        />
      </div>
      <div
        style={{ border: "1px solid #d5d5d5" }}
        className="grid grid-cols-2 bg-[#f5f5f5] p-5 my-3 rounded-[20px]"
      >
        <div
          style={{ borderRight: "1px solid #454545", paddingInline: "16px" }}
        >
          <div
            style={{ borderBottom: "1px solid #d5d5d5" }}
            className="text-center mb-2"
          >
            Processed Requests
          </div>
          <div className="flex items-center text-sm 2xl:text-base">
            <div className="w-[30%] font-semibold bg-white px-2 py-1">
              New Case :-
            </div>
            <div className="w-[70%] flex justify-between bg-white px-4 py-1">
              <div>
                Manually :{" "}
                {rpaProcessReport?.processedReqReport?.NEW_CASE?.MANUALLY || 0}
              </div>
              <div>
                RPA : {rpaProcessReport?.processedReqReport?.NEW_CASE?.RPA || 0}
              </div>
            </div>
          </div>
          <div style={{ border: "1px solid #d5d5d5", marginBlock: "8px" }} />
          <div className="flex items-center text-sm 2xl:text-base">
            <div className="w-[30%] font-semibold px-2 py-1">
              Status Update :-
            </div>
            <div className="w-[70%] flex justify-between px-4 py-1">
              <div>
                Manually :{" "}
                {rpaProcessReport?.processedReqReport?.STATUS_UPDATE
                  ?.MANUALLY || 0}
              </div>
              <div>
                RPA :{" "}
                {rpaProcessReport?.processedReqReport?.STATUS_UPDATE?.RPA || 0}
              </div>
            </div>
          </div>
        </div>
        <div className="px-4">
          <div
            style={{ borderBottom: "1px solid #d5d5d5" }}
            className="text-center mb-2"
          >
            Non Processed
          </div>
          <div className="flex items-center gap-4">
            {/* <div className="w-[20%] font-semibold">New Case :-</div> */}
            <div className="w-[100%] flex justify-between bg-white text-sm 2xl:text-base px-4 py-1">
              <div>
                New:{" "}
                <span className="font-semibold">
                  {rpaProcessReport?.nonProcessedReqReport?.NEW_CASE?.NEW || 0}
                </span>
              </div>

              <div>
                Hold:{" "}
                <span className="font-semibold">
                  {" "}
                  {getHoldCount(
                    rpaProcessReport?.nonProcessedReqReport?.NEW_CASE?.HOLD,
                    rpaProcessReport?.nonProcessedReqReport?.NEW_CASE
                      ?.STARTMANUALLY
                  )}
                </span>
              </div>
            </div>
          </div>
          <div style={{ border: "1px solid #d5d5d5", marginBlock: "8px" }} />
          <div className="flex items-center gap-4">
            {/* <div className="w-[20%] font-semibold">Status Update :-</div> */}
            <div className="w-[100%] flex justify-between text-sm 2xl:text-base px-4">
              <div>
                New:{" "}
                <span className="font-semibold">
                  {rpaProcessReport?.nonProcessedReqReport?.STATUS_UPDATE
                    ?.NEW || 0}
                </span>
              </div>
              <div>
                Hold:{" "}
                <span className="font-semibold">
                  {getHoldCount(
                    rpaProcessReport?.nonProcessedReqReport?.STATUS_UPDATE
                      ?.HOLD,
                    rpaProcessReport?.nonProcessedReqReport?.STATUS_UPDATE
                      ?.STARTMANUALLY
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr style={{ color: "#E7E7E7", marginBottom: "20px" }} />
      {loading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <div
            className={`grid grid-cols-13  text-[#797979] text-base 2xl:text-[18px] px-8`}
          >
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Request Time
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Status Update Time
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Process Time
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                TMS Stage Update Time
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Registered ID
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Hospital Name
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Application ID
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Owner Name
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Request Status
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Request Process Type
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Processed By
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                RPA Attempts
              </div>
            </div>
            <div>
              <div className="text-center text-[#191919] font-semibold mb-4">
                Error Count
              </div>
            </div>
          </div>
          {rpaErrorLogs && rpaErrorLogs.length > 0 ? (
            rpaErrorLogs?.map((error, idx) => {
              return (
                <div
                  key={idx}
                  className={`py-6 px-8 rounded-[16px] text-sm 2xl:text-base ${
                    idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                  }`}
                >
                  <div className={`grid grid-cols-13  text-[#797979]  `}>
                    <div>
                      <div>
                        {error?.createdAt
                          ? formatDateTime(error?.createdAt)
                          : "--"}
                      </div>
                    </div>
                    <div>
                      <div>
                        {error?.createdAt
                          ? formatDateTime(error?.updatedAt)
                          : "--"}
                      </div>
                    </div>
                    <div>
                      <div>
                        {error?.processTime
                          ? getTime(error?.processTime)
                          : "--"}
                      </div>
                    </div>
                    <div>
                      <div>
                        {/* {error?.tmsStageUpdateTime
                          ? formatDateTime(error?.tmsStageUpdateTime)
                          : "--"} */}
                        {error?.tmsStageUpdateTime
                          ? formatDateTime(error?.tmsStageUpdateTime)
                          : "--"}
                      </div>
                    </div>
                    <div>
                      <div>{error?.id || "--"}</div>
                    </div>
                    <div>
                      <div className="pl-2">
                        {error?.hospital?.name || "--"}
                      </div>
                    </div>

                    <div>
                      <div className="text-center">
                        {error?.hospital?.applicationId || "--"}
                      </div>
                    </div>
                    <div>
                      <div>
                        {error?.hospital?.rpaapplicationregistration
                          ?.ownerName || "--"}
                      </div>
                    </div>

                    <div>
                      <div>{error?.requestStatus || "--"}</div>
                    </div>

                    <div>
                      <div>
                        {error?.caseStatus === "NEW_CASE"
                          ? "NEW CASE"
                          : error?.requestType || "--"}
                      </div>
                    </div>
                    <div>
                      <div>{error?.processedBy || "--"}</div>
                    </div>
                    <div className="flex justify-center">
                      <div
                        style={{ borderBottom: "1px solid " }}
                        className="w-fit h-fit text-[#017C57] cursor-pointer"
                        onClick={() => {
                          if (error?.rpaUpdates?.rpaCallHistory) {
                            setRpaAttempt(error?.rpaUpdates?.rpaCallHistory);
                          }
                        }}
                      >
                        {error?.attempt || "0"}
                      </div>
                    </div>
                    <div
                      className="w-full flex justify-center"
                      onClick={() => {
                        setOpenErrorLog(true);
                        setSelectedRpaLog(error);
                      }}
                    >
                      <div
                        style={{ borderBottom: "1px solid " }}
                        className="w-fit h-fit text-[#017C57] cursor-pointer"
                      >
                        {error?.rpaerrorlogs?.length}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="h-[300px] text-xl flex justify-center items-center font-semibold">
              No Query Request Logs Found
            </div>
          )}
        </div>
      )}
      {selectedRpaLog && openErrorLog && (
        <div className="fixed top-0 left-0 h-screen w-screen flex justify-center items-center bg-[#017C5780] z-[1201]">
          <div className="relative h-[70%] w-[70%] bg-white rounded-[20px] py-4 px-6 ">
            <div
              className="absolute top-4 right-5 cursor-pointer"
              onClick={() => {
                setSelectedRpaLog(null);
                setOpenErrorLog(false);
              }}
            >
              <Close />
            </div>
            <div className="text-2xl font-semibold">Error Logs</div>
            <div className="mt-5">
              <div
                className={`grid grid-cols-5  text-[#797979] text-[18px] px-8`}
              >
                <div>
                  <div className="text-[#191919] font-semibold mb-4">
                    Application ID
                  </div>
                </div>
                <div>
                  <div className="text-[#191919] font-semibold mb-4">
                    {" "}
                    Error Code
                  </div>{" "}
                </div>
                <div className="col-span-2">
                  <div className="text-[#191919] font-semibold mb-4">
                    {" "}
                    Error Reason
                  </div>{" "}
                </div>
                <div>
                  <div className="text-[#191919] font-semibold mb-4">
                    {" "}
                    Created At
                  </div>
                </div>
              </div>
              {selectedRpaLog && selectedRpaLog?.rpaerrorlogs.length > 0 ? (
                selectedRpaLog?.rpaerrorlogs?.map((error, idx) => {
                  return (
                    <div
                      key={idx}
                      className={`py-6 px-8 rounded-[16px] ${
                        idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                      }`}
                    >
                      <div
                        className={`grid grid-cols-5  text-[#797979] text-[18px] `}
                      >
                        <div>
                          <div>{error.applicationId || "--"}</div>
                        </div>
                        <div>
                          <div>{error.errorCode || "--"}</div>
                        </div>
                        <div className="col-span-2">
                          <div>{error.errorReason || "--"}</div>
                        </div>
                        <div>
                          <div>
                            {error.createdAt
                              ? formatDateTime(error?.createdAt)
                              : "--"}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="h-[300px] text-xl flex justify-center items-center font-semibold">
                  No Error Logs
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {rpaAttempt && (
        <RpaAttempts attempts={rpaAttempt} setOpen={setRpaAttempt} />
      )}
      <div className="flex justify-center mt-5">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default RpaQueryRequestLog;
